import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./HorizontalScroll.module.scss";
import Chevron from "@Icons/Chevron";
import { useEffect, useRef, useState } from "react";
import wrapperHOC from "@Utils/wrapperHOC";

const HorizontalScroll = ({
  children,
  className,
  showControls = false,
  itemSize = 242,
  controlsClass = {},
  bgColor = "",
  /** Fires on the scrollable element (scroll does not bubble to parents). */
  onHorizontalScroll,
}: any) => {
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const scrollDiv: any = useRef();

  const handleLeftClick = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (scrollDiv.current)
      scrollDiv.current.scrollTo({
        left: scrollDiv.current.scrollLeft - itemSize,
        behavior: "smooth",
      });
    setShowRight(true);
    setShowLeft(scrollDiv.current.scrollLeft > itemSize);
  };

  const handleRightClick = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (scrollDiv.current)
      scrollDiv.current.scrollTo({
        left: scrollDiv.current.scrollLeft + itemSize,
        behavior: "smooth",
      });

    setShowLeft(true);
    setShowRight(
      scrollDiv.current.scrollLeft + scrollDiv.current.clientWidth <
        scrollDiv.current.scrollWidth - itemSize,
    );
  };

  const handleOnScroll = (e: any) => {
    setShowLeft(scrollDiv.current.scrollLeft > 0);
    setShowRight(
      Math.ceil(scrollDiv.current.scrollLeft) + scrollDiv.current.clientWidth <
        scrollDiv.current.scrollWidth - 1,
    );
    onHorizontalScroll?.(e);
  };

  useEffect(() => {
    if (scrollDiv.current) {
      setTimeout(() => {
        setShowRight(() => {
          const el = scrollDiv.current;
          if (!el) return false;
          return Math.ceil(el.scrollLeft) + el.clientWidth < el.scrollWidth - 1;
        });
      }, 1000);
    }
  }, []);

  return (
    <div className={styles.hrContainer}>
      <div
        ref={scrollDiv}
        onScroll={handleOnScroll}
        className={formatClassNames(className, styles.horizontalScroll)}
      >
        {children}
      </div>
      {showControls && (
        <>
          {showLeft && (
            <div
              onClick={handleLeftClick}
              role="none"
              className={formatClassNames(
                styles.wrapper,
                styles.left,
                controlsClass,
                styles[bgColor],
              )}
              data-testid="left-carousel"
            >
              <div className={styles.icon}>
                <Chevron width="12" height="12" />
              </div>
            </div>
          )}
          {showRight && (
            <div
              onClick={handleRightClick}
              role="none"
              className={formatClassNames(
                styles.wrapper,
                styles.right,
                controlsClass,
                styles[bgColor],
              )}
              data-testid="right-carousel"
            >
              <div className={styles.icon}>
                <Chevron width="12" height="12" />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default wrapperHOC(HorizontalScroll, {
  componentName: "HorizontalScroll-Global",
  showForChina: true,
});
